var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "lunchMenus" } },
    [
      _c(
        "tabs",
        {
          attrs: {
            options: { useUrlFragment: false, defaultTabHash: _vm.selectedTab }
          }
        },
        _vm._l(_vm.schools, function(school, schoolIndex) {
          return _c(
            "tab",
            {
              key: "school_" + schoolIndex,
              attrs: { name: school.SCHOOL_TITLE, id: school.SCHOOL_ID }
            },
            [
              !!school
                ? [
                    _c("calendar", {
                      key: "calendar_" + school.SCHOOL_ID + "_" + schoolIndex,
                      attrs: { selectedSchool: school }
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }